/** @jsx jsx */
import Heading from '@fify.at/gatsby-theme-base/src/components/Heading/Heading';
import Section from '@fify.at/gatsby-theme-base/src/components/Section/Section';
import { jsx } from 'theme-ui';
import Icon from '@fify.at/gatsby-theme-base/src/components/Icon/Icon';
import Box from '@fify.at/gatsby-theme-base/src/components/Box/Box';
import Flex from '@fify.at/gatsby-theme-base/src/components/Flex/Flex';
import SchedulerForm from '../Forms/SchedulerForm';
import Text_calltoaction from '../raw_templates/Text_calltoaction';
// import ListingBuyCalculator
//   from '@fify.at/gatsby-theme-listings/src/components/ListingBuyCalculator/ListingBuyCalculator';

export default function ScheduleForm(props) {
  return (
    <Section
      {...props}
      sx={{
        maxWidth: [null, null, 500, 760, 1100],
        marginX: 'auto',
        boxShadow: `0 0 30px rgba(0,0,0,0.1)`,
        backgroundColor: '#fff',
      }}
    >
      <Heading
        sx={{ color: 'primary', fontWeight: 'bold', textAlign: 'center' }}
      >
        Termin vereinbaren
      </Heading>
      <SchedulerForm location={props.location} />
      <p
        sx={{
          marginY: '3',
        }}
      >
        <em>
          Datenschutz: Die im Kontaktformular angegebenen Daten werden
          ausschließlich für die Terminvereinbarung herangezogen.
        </em>
      </p>
    </Section>
  );
}
